'use client';

import NextError from 'next/error';
import { usePathname } from 'next/navigation';
import { logError } from '@/lib/log-client';

import { useEffect } from 'react';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
	const pathname = usePathname();

	useEffect(() => {

		const status = error.message == 'Invalid URL' ? 404 : 500;
		console.error('Global error:', {
			error: error.name,
			message: error.message,
			cause: error.cause,
			stack: error.stack,
			digest: error.digest,
			host: window.location.href,
			path: pathname,
			statusCode: status,
		});

		logError(error.message, {
			stack: error.stack,
			data: {
				source: 'client:global-error',
				digest: error.digest,
				url: window.location.href,
				path: pathname,
				statusCode: status,
			},
		});

		// Also fire via sendBeacon as fallback (global-error may unmount quickly)
		try {
			const key = process.env.NEXT_PUBLIC_LOG_INGEST_KEY ?? '';
			const url = key ? `/api/logs?key=${encodeURIComponent(key)}` : '/api/logs';
			const body = JSON.stringify([{
				level: 'error',
				source: 'client:global-error',
				message: error.message,
				stack: error.stack,
				data: { digest: error.digest, url: window.location.href, path: pathname, statusCode: status },
				timestamp: new Date().toISOString(),
				sessionId: crypto.randomUUID(),
			}]);
			navigator.sendBeacon?.(url, new Blob([body], { type: 'application/json' }));
		} catch {
		}
	}, [error]);

	return (
		<html>
			<body>
				{/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
				<NextError statusCode={0} />
				Oops! An Error has occurred <br />
				<br /> <pre>{JSON.stringify(error)}</pre>

			</body>
		</html>
	);
}
